<form [formGroup]="editAssetForm" (ngSubmit)="onSubmit()">
    <div class="modal-header">
        <h5 class="modal-title">Rename Item</h5>
        <button type="button" class="close" (click)="activeModal.close()">
            <span>×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="validation-summary-errors" *ngIf="editAssetForm.touched && editAssetForm.invalid">
            <ul>
                <li *ngIf="editAssetForm.touched && editAssetForm.controls['assetName'].invalid">Asset Name can't be empty.</li>
                <li *ngIf="editAssetForm.touched && editAssetForm.errors?.fileType">This file extension is not allowed.</li>
            </ul>
        </div>
        <div class="form-group">
            <label for="input" class="form-control-label">New Name</label>
            <input
                type="text"
                class="form-control"
                formControlName="assetName"
                [ngClass]="{ 'input-validation-error': editAssetForm.touched && editAssetForm.controls['assetName'].invalid }"
            />
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary btn-sm" [disabled]="formBusy">Ok</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.close()">Cancel</button>
    </div>
</form>
